// src/polyfills.js
import { Buffer } from "buffer";

window.Buffer = Buffer;
